import { Link } from "react-router-dom";
import { THEMES } from "../themes";
import translate from "../locales";
import logoMortsel from "../assets/images/mortsel_logo_kleur.png";

export function ChooseTheme() {
  const title = translate(["start", "title"]);
  return (
    <>
      <title>{title}</title>
      <main className="choose-theme">
        <div className="choose-theme__header-wrapper">
          <div className="choose-theme__header">
            <a href={translate(["general", "bpart_url"])}>
              <img
                src={logoMortsel}
                alt={translate(["general", "logo_mortsel_alt"])}
                className="choose-theme__logo"
              />
            </a>
            <div className="choose-theme__intro">
              <h1 className="choose-theme__title">{title}</h1>
              <p className="choose-theme__description">
                {translate(["start", "introduction"])}
              </p>
            </div>
          </div>
        </div>

        <div className="choose-theme__options">
          {Object.keys(THEMES).map((theme) => (
            <Link to={theme} key={theme} className="choose-theme__option">
              {translate([theme, "name"])}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="currentColor"
                className="choose-theme__option-icon"
              >
                <path d="M15.2188 11.25H0V8.75H15.2188L8.21875 1.75L10 0L20 10L10 20L8.21875 18.25L15.2188 11.25Z" />
              </svg>
            </Link>
          ))}
        </div>
      </main>
    </>
  );
}
